// extracted by mini-css-extract-plugin
export default {"title":"Title_title__wClvL","titleDescription":"Title_titleDescription__9qNWq"};